// // // Updated: 02-04-2026
// // // Changes:
// // // - visit_type filter added to filteredVisits logic
// // // - handleSaveAction: "notes" type removed (merged into feedback)
// // // - isLoading state added and passed to SiteVisitForm
// // // - filters initial state includes visit_type: "all"

// // import React, { useEffect, useState } from "react";
// // import { Plus, Search } from "lucide-react";
// // import { AnimatePresence } from "framer-motion";
// // import { useNavigate } from "react-router-dom";

// // import SiteVisitCard    from "../components/siteVisit/SiteVisitCard";
// // import SiteVisitForm    from "../components/siteVisit/SiteVisitForm";
// // import SiteVisitFilters from "../components/siteVisit/SiteVisitFilters";

// // import api from "../api/api";
// // import { useAuth } from "../api/authContext";

// // import "../css/sitevisit/sitevisitpage.css";

// // export default function SiteVisitPage() {
// //   const navigate = useNavigate();
// //   const { token, isAdmin } = useAuth();

// //   const [visits,     setVisits]     = useState([]);
// //   const [leads,      setLeads]      = useState([]);
// //   const [properties, setProperties] = useState([]);

// //   const [loading,      setLoading]      = useState(true);
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [showForm,     setShowForm]     = useState(false);
// //   const [editingVisit, setEditingVisit] = useState(null);

// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [filters,    setFilters]    = useState({ status: "all", visit_type: "all" });

// //   /* ── Auth guard ── */
// //   useEffect(() => {
// //     if (!token) { navigate("/login"); return; }
// //     fetchAll();
// //   }, [token]);

// //   /* ── Fetch all data ── */
// //   const fetchAll = async () => {
// //     try {
// //       setLoading(true);
// //       const [visitRes, leadRes, propertyRes] = await Promise.all([
// //         api.get("/sitevisits"),
// //         api.get("/leads/all"),
// //         api.get("/properties"),
// //       ]);
// //       setVisits(visitRes.data?.data || []);
// //       setLeads(leadRes.data || []);
// //       setProperties(propertyRes.data || []);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       if (err.response?.status === 401) navigate("/login");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   /* ── Save action from card (feedback / status) ── */
// //   const handleSaveAction = async (type, value, visitId) => {
// //     if (!value) return;
// //     const payload = {};
// //     if (type === "feedback") payload.feedback = value;
// //     if (type === "status")   payload.status   = value;

// //     // Optimistic update
// //     setVisits((prev) => prev.map((v) => v._id === visitId ? { ...v, ...payload } : v));

// //     try {
// //       await api.patch(`/siteVisits/${visitId}`, payload);
// //     } catch (err) {
// //       console.error("Save failed", err);
// //       fetchAll();
// //     }
// //   };

// //   /* ── Create / Update ── */
// //   const handleSubmit = async (data) => {
// //     try {
// //       setIsSubmitting(true);
// //       if (editingVisit) {
// //         await api.put(`/sitevisits/${editingVisit._id}`, data);
// //       } else {
// //         await api.post("/sitevisits/create", data);
// //       }
// //       fetchAll();
// //       setShowForm(false);
// //       setEditingVisit(null);
// //     } catch (err) {
// //       console.error("Save error:", err);
// //       alert("Error saving site visit");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   /* ── Filter logic ── */
// //   const filteredVisits = visits
// //     .map((visit) => {
// //       const leadObj =
// //         typeof visit.lead_id === "object"
// //           ? visit.lead_id
// //           : leads.find((l) => l._id === visit.lead_id) || null;
// //       const propertyObj =
// //         typeof visit.property_id === "object"
// //           ? visit.property_id
// //           : properties.find((p) => p._id === visit.property_id) || null;
// //       return { ...visit, leadObj, propertyObj };
// //     })
// //     .filter((visit) => {
// //       if (!visit.leadObj || !visit.propertyObj) return false;

// //       const search = searchTerm.toLowerCase();
// //       const matchesSearch =
// //         visit.leadObj?.full_name?.toLowerCase().includes(search) ||
// //         visit.propertyObj?.propertyName?.toLowerCase().includes(search);

// //       const matchesStatus =
// //         filters.status === "all" || visit.status === filters.status;

// //       const matchesType =
// //         filters.visit_type === "all" || visit.visit_type === filters.visit_type;

// //       return matchesSearch && matchesStatus && matchesType;
// //     });

// //   return (
// //     <div className="sitevisits-page">
// //       {/* HEADER */}
// //       <div className="sitevisits-header">
// //         <div>
// //           <h1>Site Visits</h1>
// //           <p>Schedule and track property viewings</p>
// //         </div>
// //         <button
// //           className="btn-primary"
// //           onClick={() => { setEditingVisit(null); setShowForm(true); }}
// //         >
// //           <Plus size={16} /> Schedule Visit
// //         </button>
// //       </div>

// //       {/* SEARCH + FILTER */}
// //       <div className="sitevisits-toolbar">
// //         <div className="search-box">
// //           <Search size={16} />
// //           <input
// //             placeholder="Search by lead or property..."
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //           />
// //         </div>
// //         <SiteVisitFilters filters={filters} setFilters={setFilters} />
// //       </div>

// //       {/* FORM MODAL */}
// //       <AnimatePresence>
// //         {showForm && (
// //           <SiteVisitForm
// //             visit={editingVisit}
// //             leads={leads}
// //             properties={properties}
// //             onSubmit={handleSubmit}
// //             onCancel={() => { setShowForm(false); setEditingVisit(null); }}
// //             isLoading={isSubmitting}
// //           />
// //         )}
// //       </AnimatePresence>

// //       {/* GRID */}
// //       <div className="sitevisits-grid">
// //         {loading ? (
// //           <p className="loading-text">Loading site visits...</p>
// //         ) : filteredVisits.length === 0 ? (
// //           <p className="empty-text">No site visits found</p>
// //         ) : (
// //           filteredVisits.map((visit, index) => (
// //             <SiteVisitCard
// //               key={visit._id}
// //               visit={visit}
// //               lead={visit.leadObj}
// //               property={visit.propertyObj}
// //               index={index}
// //               isAdmin={isAdmin}
// //               onEdit={() => { setEditingVisit(visit); setShowForm(true); }}
// //               onDelete={async () => {
// //                 if (!window.confirm("Delete this site visit?")) return;
// //                 await api.delete(`/sitevisits/${visit._id}`);
// //                 fetchAll();
// //               }}
// //               onSave={handleSaveAction}
// //             />
// //           ))
// //         )}
// //       </div>
// //     </div>
// //   );
// // }
// // Updated: 23-05-2026
// // Changes:
// // - Reads URL query param ?status=xxx on mount
// //   so Dashboard "Upcoming Visits" link pre-filters to status=scheduled

// import React, { useEffect, useState } from "react";
// import { Plus, Search } from "lucide-react";
// import { AnimatePresence } from "framer-motion";
// import { useNavigate, useLocation } from "react-router-dom";

// import SiteVisitCard    from "../components/siteVisit/SiteVisitCard";
// import SiteVisitForm    from "../components/siteVisit/SiteVisitForm";
// import SiteVisitFilters from "../components/siteVisit/SiteVisitFilters";

// import api from "../api/api";
// import { useAuth } from "../api/authContext";

// import "../css/sitevisit/sitevisitpage.css";

// export default function SiteVisitPage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { token, isAdmin } = useAuth();

//   const [visits,     setVisits]     = useState([]);
//   const [leads,      setLeads]      = useState([]);
//   const [properties, setProperties] = useState([]);

//   const [loading,      setLoading]      = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showForm,     setShowForm]     = useState(false);
//   const [editingVisit, setEditingVisit] = useState(null);

//   const [searchTerm, setSearchTerm] = useState("");

//   /* ── Read ?status= and ?visit_type= from URL on mount ── */
//   const initFilters = () => {
//     const p = new URLSearchParams(location.search);
//     return {
//       status:     p.get("status")     || "all",
//       visit_type: p.get("visit_type") || "all",
//     };
//   };

//   const [filters, setFilters] = useState(initFilters);

//   useEffect(() => {
//     setFilters(initFilters());
//   }, [location.search]);

//   /* ── Auth guard ── */
//   useEffect(() => {
//     if (!token) { navigate("/login"); return; }
//     fetchAll();
//   }, [token]);

//   /* ── Fetch all data ── */
//   const fetchAll = async () => {
//     try {
//       setLoading(true);
//       const [visitRes, leadRes, propertyRes] = await Promise.all([
//         api.get("/sitevisits"),
//         api.get("/leads/all"),
//         api.get("/properties"),
//       ]);
//       setVisits(visitRes.data?.data || []);
//       setLeads(leadRes.data || []);
//       setProperties(propertyRes.data || []);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       if (err.response?.status === 401) navigate("/login");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ── Save action from card (feedback / status) ── */
//   const handleSaveAction = async (type, value, visitId) => {
//     if (!value) return;
//     const payload = {};
//     if (type === "feedback") payload.feedback = value;
//     if (type === "status")   payload.status   = value;

//     setVisits((prev) => prev.map((v) => v._id === visitId ? { ...v, ...payload } : v));
//     try {
//       await api.patch(`/siteVisits/${visitId}`, payload);
//     } catch (err) {
//       console.error("Save failed", err);
//       fetchAll();
//     }
//   };

//   /* ── Create / Update ── */
//   const handleSubmit = async (data) => {
//     try {
//       setIsSubmitting(true);
//       if (editingVisit) {
//         await api.put(`/sitevisits/${editingVisit._id}`, data);
//       } else {
//         await api.post("/sitevisits/create", data);
//       }
//       fetchAll();
//       setShowForm(false);
//       setEditingVisit(null);
//     } catch (err) {
//       console.error("Save error:", err);
//       alert("Error saving site visit");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   /* ── Filter logic ── */
//   const filteredVisits = visits
//     .map((visit) => {
//       const leadObj =
//         typeof visit.lead_id === "object"
//           ? visit.lead_id
//           : leads.find((l) => l._id === visit.lead_id) || null;
//       const propertyObj =
//         typeof visit.property_id === "object"
//           ? visit.property_id
//           : properties.find((p) => p._id === visit.property_id) || null;
//       return { ...visit, leadObj, propertyObj };
//     })
//     .filter((visit) => {
//       if (!visit.leadObj || !visit.propertyObj) return false;

//       const search = searchTerm.toLowerCase();
//       const matchesSearch =
//         visit.leadObj?.full_name?.toLowerCase().includes(search) ||
//         visit.propertyObj?.propertyName?.toLowerCase().includes(search);

//       const matchesStatus =
//         filters.status === "all" || visit.status === filters.status;

//       const matchesType =
//         filters.visit_type === "all" || visit.visit_type === filters.visit_type;

//       return matchesSearch && matchesStatus && matchesType;
//     });

//   return (
//     <div className="sitevisits-page">
//       {/* HEADER */}
//       <div className="sitevisits-header">
//         <div>
//           <h1>Site Visits</h1>
//           <p>Schedule and track property viewings</p>
//         </div>
//         <button className="btn-primary" onClick={() => { setEditingVisit(null); setShowForm(true); }}>
//           <Plus size={16} /> Schedule Visit
//         </button>
//       </div>

//       {/* SEARCH + FILTER */}
//       <div className="sitevisits-toolbar">
//         <div className="search-box">
//           <Search size={16} />
//           <input
//             placeholder="Search by lead or property..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>
//         <SiteVisitFilters filters={filters} setFilters={setFilters} />
//       </div>

//       {/* FORM MODAL */}
//       <AnimatePresence>
//         {showForm && (
//           <SiteVisitForm
//             visit={editingVisit}
//             leads={leads}
//             properties={properties}
//             onSubmit={handleSubmit}
//             onCancel={() => { setShowForm(false); setEditingVisit(null); }}
//             isLoading={isSubmitting}
//           />
//         )}
//       </AnimatePresence>

//       {/* GRID */}
//       <div className="sitevisits-grid">
//         {loading ? (
//           <p className="loading-text">Loading site visits...</p>
//         ) : filteredVisits.length === 0 ? (
//           <p className="empty-text">No site visits found</p>
//         ) : (
//           filteredVisits.map((visit, index) => (
//             <SiteVisitCard
//               key={visit._id}
//               visit={visit}
//               lead={visit.leadObj}
//               property={visit.propertyObj}
//               index={index}
//               isAdmin={isAdmin}
//               onEdit={() => { setEditingVisit(visit); setShowForm(true); }}
//               onDelete={async () => {
//                 if (!window.confirm("Delete this site visit?")) return;
//                 await api.delete(`/sitevisits/${visit._id}`);
//                 fetchAll();
//               }}
//               onSave={handleSaveAction}
//             />
//           ))
//         )}
//       </div>
//     </div>
//   );
// }
// Updated: 23-05-2026
// Changes:
// - Reads URL query param ?status=xxx on mount
//   so Dashboard "Upcoming Visits" link pre-filters to status=scheduled
// - Added "Created By" agent filter dropdown (built from actual visit data)

import React, { useEffect, useState } from "react";
import { Handshake, Search, MapPinned, Users } from "lucide-react";
import { AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

import SiteVisitCard    from "../components/siteVisit/SiteVisitCard";
import SiteVisitForm    from "../components/siteVisit/SiteVisitForm";
import SiteVisitFilters from "../components/siteVisit/SiteVisitFilters";
import SelfVisitCard    from "../components/siteVisit/SelfVisitCard";
import SelfVisitForm    from "../components/siteVisit/SelfVisitForm";
import BothVisitForm    from "../components/siteVisit/BothVisitForm";
import PeriodFilterBar  from "../components/common/PeriodFilterBar";

import api from "../api/api";
import { useAuth } from "../api/authContext";
import { toISTDateString } from "../utils/datetime";
import { getPeriodRange, isAnyDateInRange } from "../utils/periodFilter";

import "../css/sitevisit/sitevisitpage.css";

export default function SiteVisitPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, isAdmin } = useAuth();

  const [visits,     setVisits]     = useState([]);
  const [leads,      setLeads]      = useState([]);
  const [properties, setProperties] = useState([]);

  const [loading,      setLoading]      = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showForm,     setShowForm]     = useState(false);
  const [editingVisit, setEditingVisit] = useState(null);
  const [showBothForm, setShowBothForm] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [createdBy,  setCreatedBy]  = useState("all");   // ← new

  /* ── Period filter (Daily/Weekly/Monthly/Custom) — shared across all 3 tabs.
        Matches a visit by EITHER its scheduled date or its created date. ── */
  const [period,     setPeriod]     = useState("all");
  const [weekAnchor, setWeekAnchor] = useState(() => new Date());
  const [customFrom, setCustomFrom] = useState("");
  const [customTo,   setCustomTo]   = useState("");

  /* ── Self Visit state ── */
  const initTab = () => {
    const t = new URLSearchParams(location.search).get("tab");
    return t === "self" || t === "both" ? t : "site";
  };

  const initSelfFilters = () => {
    const p = new URLSearchParams(location.search);
    return {
      status:   p.get("tab") === "self" ? (p.get("status") || "all") : "all",
      property: "all",
      user:     "all",
      date:     "",
    };
  };

  const [activeTab,        setActiveTab]        = useState(initTab);   // "site" | "self"
  const [selfVisits,       setSelfVisits]       = useState([]);
  const [showSelfForm,     setShowSelfForm]     = useState(false);
  const [editingSelfVisit, setEditingSelfVisit] = useState(null);
  const [selfFilters,      setSelfFilters]      = useState(initSelfFilters);

  /* ── Read ?status= and ?visit_type= from URL on mount ── */
  const initFilters = () => {
    const p = new URLSearchParams(location.search);
    return {
      status:     p.get("status")     || "all",
      visit_type: p.get("visit_type") || "all",
    };
  };

  const [filters, setFilters] = useState(initFilters);

  useEffect(() => {
    setFilters(initFilters());
    setActiveTab(initTab());
    setSelfFilters(initSelfFilters());
  }, [location.search]);

  /* ── Auth guard ── */
  useEffect(() => {
    if (!token) { navigate("/login"); return; }
    fetchAll();
  }, [token]);

  /* ── Fetch all data ── */
  const fetchAll = async () => {
    try {
      setLoading(true);
      const [visitRes, leadRes, propertyRes, selfRes] = await Promise.all([
        api.get("/sitevisits"),
        api.get("/leads/all"),
        api.get("/properties"),
        api.get("/self-visits"),
      ]);
      setVisits(visitRes.data?.data || []);
      setLeads(leadRes.data || []);
      setProperties(propertyRes.data || []);
      setSelfVisits(selfRes.data?.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
      if (err.response?.status === 401) navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  /* ── Save action from card (feedback / status / reschedule) ── */
  const handleSaveAction = async (type, value, visitId, extra = {}) => {
    const payload = { ...extra };
    if (type === "feedback") payload.feedback = value;
    if (type === "status")   payload.status   = value;
    if (Object.keys(payload).length === 0) return;

    setVisits((prev) => prev.map((v) => v._id === visitId ? { ...v, ...payload } : v));
    try {
      await api.patch(`/sitevisits/${visitId}`, payload);
      fetchAll();
    } catch (err) {
      console.error("Save failed", err);
      fetchAll();
    }
  };

  /* ── Create / Update ── */
  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      if (editingVisit) {
        await api.put(`/sitevisits/${editingVisit._id}`, data);
      } else {
        await api.post("/sitevisits/create", data);
      }
      fetchAll();
      setShowForm(false);
      setEditingVisit(null);
    } catch (err) {
      console.error("Save error:", err);
      alert("Error saving site visit");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ── Both Direct Visit: creates a Buyer (site) visit + Seller (self) visit together ── */
  const handleBothSubmit = async (data) => {
    const {
      lead_id, property_id, scheduled_date, status, visit_type,
      feedback, remark,
      seller_name, seller_phone, seller_email,
    } = data;
    try {
      setIsSubmitting(true);
      await Promise.all([
        api.post("/sitevisits/create", {
          lead_id, property_id, scheduled_date, status, visit_type, feedback, remark,
        }),
        api.post("/self-visits/create", {
          property_id, scheduled_date, status, visit_type, feedback, remark,
          seller_name, seller_phone, seller_email,
        }),
      ]);
      fetchAll();
      setShowBothForm(false);
    } catch (err) {
      console.error("Both visit save error:", err);
      alert("Error saving visit");
    } finally {
      setIsSubmitting(false);
    }
  };

  /* ── Build unique agent list from actual data ── */
  const agentOptions = [...new Set(
    visits.map((v) => v.createdByEmail).filter(Boolean)
  )].sort();

  /* ── Filter logic ── */
  const periodRange = getPeriodRange(period, { weekAnchor, customFrom, customTo });

  const filteredVisits = visits
    .map((visit) => {
      const leadObj =
        typeof visit.lead_id === "object"
          ? visit.lead_id
          : leads.find((l) => l._id === visit.lead_id) || null;
      const propertyObj =
        typeof visit.property_id === "object"
          ? visit.property_id
          : properties.find((p) => p._id === visit.property_id) || null;
      return { ...visit, leadObj, propertyObj };
    })
    .filter((visit) => {
      if (!visit.leadObj || !visit.propertyObj) return false;

      const search = searchTerm.toLowerCase();
      const matchesSearch =
        visit.leadObj?.full_name?.toLowerCase().includes(search) ||
        visit.propertyObj?.propertyName?.toLowerCase().includes(search);

      const matchesStatus =
        filters.status === "all" || visit.status === filters.status;

      const matchesType =
        filters.visit_type === "all" || visit.visit_type === filters.visit_type;

      const matchesAgent =
        createdBy === "all" || visit.createdByEmail === createdBy;   // ← new

      const matchesPeriod = isAnyDateInRange([visit.scheduled_date, visit.createdAt], periodRange);

      return matchesSearch && matchesStatus && matchesType && matchesAgent && matchesPeriod;
    });

  /* ── Self Visit: create / update ── */
  const handleSelfSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      if (editingSelfVisit) {
        await api.put(`/self-visits/${editingSelfVisit._id}`, data);
      } else {
        await api.post("/self-visits/create", data);
      }
      fetchAll();
      setShowSelfForm(false);
      setEditingSelfVisit(null);
    } catch (err) {
      console.error("Self visit save error:", err);
      alert("Error saving seller visit");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelfDelete = async (id) => {
    if (!window.confirm("Delete this seller visit?")) return;
    try {
      await api.delete(`/self-visits/${id}`);
      fetchAll();
    } catch (err) {
      console.error("Self visit delete error:", err);
    }
  };

  /* ── Self Visit: filter option lists ── */
  const selfUserOptions = [...new Set(
    selfVisits.map((v) => v.createdByEmail).filter(Boolean)
  )].sort();

  const selfPropertyOptions = [...new Map(
    selfVisits
      .map((v) => (typeof v.property_id === "object" ? v.property_id : null))
      .filter(Boolean)
      .map((p) => [p._id, p])
  ).values()];

  /* ── Self Visit: filter logic (status, property, user, date) ── */
  const filteredSelfVisits = selfVisits
    .map((visit) => ({
      ...visit,
      propertyObj:
        typeof visit.property_id === "object"
          ? visit.property_id
          : properties.find((p) => p._id === visit.property_id) || null,
    }))
    .filter((visit) => {
      const matchesStatus =
        selfFilters.status === "all" || visit.status === selfFilters.status;

      const propId =
        typeof visit.property_id === "object" ? visit.property_id?._id : visit.property_id;
      const matchesProperty =
        selfFilters.property === "all" || propId === selfFilters.property;

      const matchesUser =
        selfFilters.user === "all" || visit.createdByEmail === selfFilters.user;

      const matchesDate =
        !selfFilters.date ||
        toISTDateString(visit.scheduled_date) === selfFilters.date;

      const matchesPeriod = isAnyDateInRange([visit.scheduled_date, visit.createdAt], periodRange);

      const search = searchTerm.toLowerCase();
      const matchesSearch =
        !search || visit.propertyObj?.propertyName?.toLowerCase().includes(search);

      return matchesStatus && matchesProperty && matchesUser && matchesDate && matchesPeriod && matchesSearch;
    });

  /* ── Both Direct: combined list of direct-type buyer + seller visits ── */
  const bothDirectVisits = [
    ...filteredVisits
      .filter((v) => v.visit_type === "direct")
      .map((v) => ({ ...v, _kind: "buyer" })),
    ...filteredSelfVisits
      .filter((v) => v.visit_type === "direct")
      .map((v) => ({ ...v, _kind: "seller" })),
  ].sort((a, b) => new Date(b.scheduled_date) - new Date(a.scheduled_date));

  return (
    <div className="sitevisits-page">
      {/* HEADER */}
      <div className="sitevisits-header">
        <div>
          <h1>Site Visits</h1>
          <p>Schedule and track property viewings</p>
        </div>
        <div className="sitevisits-actions">
          <button
            className="btn-visit"
            onClick={() => { setEditingSelfVisit(null); setShowSelfForm(true); }}
          >
            <MapPinned size={16} /> Seller Visit
          </button>
          <button className="btn-visit" onClick={() => setShowBothForm(true)}>
            <Users size={16} /> Both Visits
          </button>
          <button className="btn-visit" onClick={() => { setEditingVisit(null); setShowForm(true); }}>
            <Handshake size={16} /> Buyer Visit
          </button>
        </div>
      </div>

      {/* TABS */}
      <div className="sitevisits-tabs">
        <button
          className={`sitevisits-tab ${activeTab === "site" ? "active" : ""}`}
          onClick={() => setActiveTab("site")}
        >
          Buyer Visits ({visits.length})
        </button>
        <button
          className={`sitevisits-tab ${activeTab === "self" ? "active" : ""}`}
          onClick={() => setActiveTab("self")}
        >
          Seller Visits ({selfVisits.length})
        </button>
        <button
          className={`sitevisits-tab ${activeTab === "both" ? "active" : ""}`}
          onClick={() => setActiveTab("both")}
        >
          Both Direct ({bothDirectVisits.length})
        </button>
      </div>

      <PeriodFilterBar
        period={period} onPeriodChange={setPeriod}
        weekAnchor={weekAnchor} onWeekAnchorChange={setWeekAnchor}
        customFrom={customFrom} onCustomFromChange={setCustomFrom}
        customTo={customTo} onCustomToChange={setCustomTo}
      />

      {/* ════════════ SITE VISITS TAB ════════════ */}
      {activeTab === "site" && (
        <>
          {/* SEARCH + FILTER */}
          <div className="sitevisits-toolbar">
            <div className="search-box">
              <Search size={16} />
              <input
                placeholder="Search by lead or property..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <SiteVisitFilters filters={filters} setFilters={setFilters} />

            {/* Created By filter */}
            <select value={createdBy} onChange={(e) => setCreatedBy(e.target.value)}>
              <option value="all">All Agents</option>
              {agentOptions.map((email) => (
                <option key={email} value={email}>{email}</option>
              ))}
            </select>
          </div>

          {/* GRID */}
          <div className="sitevisits-grid">
            {loading ? (
              <p className="loading-text">Loading buyer visits...</p>
            ) : filteredVisits.length === 0 ? (
              <p className="empty-text">No buyer visits found</p>
            ) : (
              filteredVisits.map((visit, index) => (
                <SiteVisitCard
                  key={visit._id}
                  visit={visit}
                  lead={visit.leadObj}
                  property={visit.propertyObj}
                  index={index}
                  isAdmin={isAdmin}
                  onEdit={() => { setEditingVisit(visit); setShowForm(true); }}
                  onDelete={async () => {
                    if (!window.confirm("Delete this buyer visit?")) return;
                    await api.delete(`/sitevisits/${visit._id}`);
                    fetchAll();
                  }}
                  onSave={handleSaveAction}
                />
              ))
            )}
          </div>
        </>
      )}

      {/* ════════════ SELF VISITS TAB ════════════ */}
      {activeTab === "self" && (
        <>
          {/* SEARCH + FILTERS (status, property, user, date) */}
          <div className="sitevisits-toolbar">
            <div className="search-box">
              <Search size={16} />
              <input
                placeholder="Search by property..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <select
              value={selfFilters.status}
              onChange={(e) => setSelfFilters((p) => ({ ...p, status: e.target.value }))}
            >
              <option value="all">All Status</option>
              <option value="scheduled">Scheduled</option>
              <option value="completed">Completed</option>
              <option value="rescheduled">Rescheduled</option>
              <option value="cancelled">Cancelled</option>
            </select>

            <select
              value={selfFilters.property}
              onChange={(e) => setSelfFilters((p) => ({ ...p, property: e.target.value }))}
            >
              <option value="all">All Properties</option>
              {selfPropertyOptions.map((p) => (
                <option key={p._id} value={p._id}>{p.propertyName}</option>
              ))}
            </select>

            {isAdmin && (
              <select
                value={selfFilters.user}
                onChange={(e) => setSelfFilters((p) => ({ ...p, user: e.target.value }))}
              >
                <option value="all">All Users</option>
                {selfUserOptions.map((email) => (
                  <option key={email} value={email}>{email}</option>
                ))}
              </select>
            )}

            <input
              type="date"
              value={selfFilters.date}
              onChange={(e) => setSelfFilters((p) => ({ ...p, date: e.target.value }))}
            />
          </div>

          {/* GRID */}
          <div className="sitevisits-grid">
            {loading ? (
              <p className="loading-text">Loading seller visits...</p>
            ) : filteredSelfVisits.length === 0 ? (
              <p className="empty-text">No seller visits found</p>
            ) : (
              filteredSelfVisits.map((visit, index) => (
                <SelfVisitCard
                  key={visit._id}
                  visit={visit}
                  property={visit.propertyObj}
                  index={index}
                  isAdmin={isAdmin}
                  onEdit={() => { setEditingSelfVisit(visit); setShowSelfForm(true); }}
                  onDelete={() => handleSelfDelete(visit._id)}
                />
              ))
            )}
          </div>
        </>
      )}

      {/* ════════════ BOTH DIRECT TAB ════════════ */}
      {activeTab === "both" && (
        <>
          {/* SEARCH */}
          <div className="sitevisits-toolbar">
            <div className="search-box">
              <Search size={16} />
              <input
                placeholder="Search by property..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* GRID */}
          <div className="sitevisits-grid">
            {loading ? (
              <p className="loading-text">Loading direct visits...</p>
            ) : bothDirectVisits.length === 0 ? (
              <p className="empty-text">No direct visits found</p>
            ) : (
              bothDirectVisits.map((visit, index) =>
                visit._kind === "buyer" ? (
                  <SiteVisitCard
                    key={"b-" + visit._id}
                    visit={visit}
                    lead={visit.leadObj}
                    property={visit.propertyObj}
                    index={index}
                    isAdmin={isAdmin}
                    onEdit={() => { setEditingVisit(visit); setShowForm(true); }}
                    onDelete={async () => {
                      if (!window.confirm("Delete this buyer visit?")) return;
                      await api.delete(`/sitevisits/${visit._id}`);
                      fetchAll();
                    }}
                    onSave={handleSaveAction}
                  />
                ) : (
                  <SelfVisitCard
                    key={"s-" + visit._id}
                    visit={visit}
                    property={visit.propertyObj}
                    index={index}
                    isAdmin={isAdmin}
                    onEdit={() => { setEditingSelfVisit(visit); setShowSelfForm(true); }}
                    onDelete={() => handleSelfDelete(visit._id)}
                  />
                )
              )
            )}
          </div>
        </>
      )}

      {/* FORM MODALS */}
      <AnimatePresence>
        {showForm && (
          <SiteVisitForm
            visit={editingVisit}
            leads={leads}
            properties={properties}
            onSubmit={handleSubmit}
            onCancel={() => { setShowForm(false); setEditingVisit(null); }}
            isLoading={isSubmitting}
          />
        )}
        {showSelfForm && (
          <SelfVisitForm
            visit={editingSelfVisit}
            properties={properties}
            onSubmit={handleSelfSubmit}
            onCancel={() => { setShowSelfForm(false); setEditingSelfVisit(null); }}
            isLoading={isSubmitting}
          />
        )}
        {showBothForm && (
          <BothVisitForm
            leads={leads}
            properties={properties}
            onSubmit={handleBothSubmit}
            onCancel={() => setShowBothForm(false)}
            isLoading={isSubmitting}
          />
        )}
      </AnimatePresence>
    </div>
  );
}